export const PLACEHOLDER_SRC = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
export const ERROR_SRC = PLACEHOLDER_SRC;
export const FALLBACK_SRC = PLACEHOLDER_SRC;
export const IMAGE_SIZES = [128, 256, 450, 640, 768, 1024, 1600];
export const IMAGE_WIDTH = 40;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function throttle(fn, ms) {
    let lastTime = 0;
    return () => {
        const now = Date.now();
        if (now - lastTime >= ms) {
            fn();
            lastTime = now;
        }
    };
}
export const getHeightByRatioWidth = ({ width, ratio, }) => {
    return ratio ? Math.round((width / ratio[0]) * ratio[1]) : undefined;
};
export const getActualValue = (value, actual) => {
    var _a;
    return Array.isArray(actual)
        ? (_a = actual.find(v => v >= value)) !== null && _a !== void 0 ? _a : actual[actual.length - 1]
        : actual;
};
